import { useRouter } from 'next/router';
import { useEffect, useState, ReactNode } from 'react';
import GlobalLoader from '../globalLoader';
import { useSelector } from 'react-redux';
import { ETrackingStages, routeMap } from 'Constants/trackingStages';
import {
    ROUTEMAP,
    PATHS_WITH_GARAGEID,
    PATHS_WITH_USER_DETAILS_LOADER,
} from '@/components/fakeDoor/constants';
import CustomLoader from '../loader';

import Router from '@/components/common/router';
import toast from 'react-hot-toast';
import { getGarageFromPincode } from '@/components/fakeDoor/api';
import { getUserDetails } from '@/store/modules/userDataSlice';
import Cookies from 'js-cookie';

interface RouteLoaderProps {
    children: ReactNode;
}

const RouteLoader: React.FC<RouteLoaderProps> = ({ children }) => {
    const router = useRouter();
    const isWebView = Boolean(Cookies.get('webview'));

    const [loading, setLoading] = useState(false);
    const { isLoading: isLoadingUserDetails } = useSelector(getUserDetails);
    const pathname = router.pathname;
    console.log('pathnaem', router.pathname);
    const showLoderForUserDetails =
        isLoadingUserDetails &&
        PATHS_WITH_USER_DETAILS_LOADER.includes(router.pathname);

    const { isLoading, message, type } = useSelector(
        (state: any) => state.loading
    );
    //const garageData = useSelector((state: any) => state.garage);

    useEffect(() => {
        const handleStart = () => {
            setLoading(true);
        };

        const handleComplete = () => {
            setLoading(false);
        };

        //Garage id compulsory for some paths to avoid error
        const checkGarageId = () => {
            const garageId = router.query.garageId as string | undefined;
            const pincode = router.query.pincode as string | undefined;
            const isOnlineFlow = PATHS_WITH_GARAGEID.some((path) =>
                pathname.startsWith(path)
            );

            if (isOnlineFlow && !garageId && pincode) {
                const fetchAndAppendGarageId = async () => {
                    try {
                        const res = await getGarageFromPincode(
                            pincode as string
                        );
                        localStorage.setItem('pincode', pincode as string);
                        localStorage.setItem('garage_id', res?.id);
                        if (res?.id) {
                            // Append garageId to URL params without triggering a refresh
                            router.replace(
                                {
                                    pathname: router.pathname,
                                    query: {
                                        ...router.query,
                                        garageId: res?.id,
                                    },
                                },
                                undefined,
                                { shallow: true } // Prevent a full page reload
                            );
                        }
                    } catch (error) {
                        console.error('Failed to fetch garageId:', error);
                    }
                };

                fetchAndAppendGarageId();
            }

            if (isOnlineFlow && !garageId && !pincode) {
                Router.push(ROUTEMAP.BASEPAGE);
            }
        };

        // Check garageId when the component mounts and router is ready
        if (router.isReady) {
            checkGarageId();
        }

        if (isWebView) return; //Skip loader for web view

        router.events.on('routeChangeStart', handleStart);
        router.events.on('routeChangeComplete', handleComplete);
        // router.events.on('routeChangeError', handleComplete);
        //router.events.on('routeChangeComplete', checkGarageId);

        return () => {
            router.events.off('routeChangeStart', handleStart);
            router.events.off('routeChangeComplete', handleComplete);
            //router.events.off('routeChangeError', handleComplete);
            //router.events.off('routeChangeComplete', checkGarageId);
        };
    }, [router]);

    return (
        <>
            {loading || isLoading || showLoderForUserDetails ? (
                <div>
                    {/* {pathname.includes('pickup-drop') ? (
                        <CustomLoader imagePathname="/images/loader-main.gif" />
                    ) : (
                        <GlobalLoader forceLoad={loading} />
                    )} */}
                    <Loader pathname={pathname} type={type} />
                </div>
            ) : (
                children
            )}
        </>
    );
};

export default RouteLoader;

const Loader = ({ pathname, type = '' }: { pathname: string; type: '' }) => {
    const typeLoaders = {
        custom1: <div>Custom Loader 1...</div>,
        createAppointment: <CustomLoader />,
        loadGarage: <CustomLoader />,
        custom2: <CustomLoader size={160} />,
    };

    const pathLoaders = [
        {
            pageName: 'pickup-drop',
            component: <CustomLoader size={160} />,
        },
        {
            pageName: 'periodic-service',
            component: <CustomLoader size={160} />,
        },
        {
            pageName: 'mmv',
            component: <CustomLoader size={160} />,
        },
        {
            pageName: 'address-selection',
            component: <CustomLoader size={160} />,
        },
    ];

    const getLoader = () => {
        if (type && typeLoaders[type]) {
            return typeLoaders[type];
        }

        for (const { pageName, component } of pathLoaders) {
            if (pathname.includes(pageName)) {
                return component;
            }
        }

        return <GlobalLoader forceLoad={true} />;
    };

    return <div>{getLoader()}</div>;
};
